export type {
  OpenRazorpayCheckoutInput,
  RazorpayCheckoutInitiate,
} from '../../../core/utils/razorpay-checkout.util';
import { openRazorpayCheckout as openRazorpayCheckoutCore } from '../../../core/utils/razorpay-checkout.util';
import type { OpenRazorpayCheckoutInput } from '../../../core/utils/razorpay-checkout.util';
import type { RazorpayCheckoutSuccess } from '../../../core/models/razorpay-checkout.model';

export async function openRazorpayCheckout(
  input: OpenRazorpayCheckoutInput,
): Promise<RazorpayCheckoutSuccess> {
  return openRazorpayCheckoutCore({
    ...input,
    themeColor: input.themeColor ?? '#6729ff',
  });
}
